import styled from "styled-components";

import MessageParts from "./components/MessageParts";

const UserMessage = (props) => {
  const { message = {} } = props;
  const { content = {} } = message;
  const { parts = [] } = content;

  return (
    <div className="flex w-full flex-col items-end">
      <div className="py-2">
        <div className="flex flex-row justify-end items-center mb-2 text-orange-500 text-sm font-nunito">
          You
        </div>
        <MyUserDiv style={{ paddingLeft: '16px' }}>
          <div className="flex flex-col items-end">
            {parts.map((part, i) => (
              <MessageParts key={i} part={part} />
            ))}
          </div>
        </MyUserDiv>
      </div>
    </div>
  );
};

export default UserMessage;

const MyUserDiv = styled.div`
  max-width: 400px;
  background: rgba(70, 55, 50, 1);
  border-radius: 8px 4px 8px 8px;
  padding: 12px;
  padding-right: 20px;
  color: white;
  position: relative;
`;
